<div class="app-container">
  <page-header [title]="'checkouts'" [icon]="'far-money-bill'">
    <ng-container class="header-button">
      <btn
        *ngIf="canCreate"
        [routerLink]="['/surgery']"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        [label]="'checkout.btn.create'"
        [title]="'checkout.btn.create' | translate"
        data-cy="go-checkout"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content" *ngIf="!!filters">
    <app-filter-form [filters]="filters" [entity]="'checkouts'" (onSubmit)="filter()" (onClearClick)="clearFilters()" [isFilterInvisible]="true">
      <form-row-input
        [(model)]="filters.name"
        (keydown.enter)="filter()"
        [icon]="'far-list'"
        [label]="'checkouts.name'"
        data-cy="checkout-name-filter"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="checkouts"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      (reloadList)="filter(1)"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
